var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Login'),_c('br'),_c('br'),_c('br'),_c('Forgot'),_c('br'),_c('br'),_c('br'),_c('ForgotReset'),_c('br'),_c('br'),_c('br'),_c('SignUp'),_c('br'),_c('br'),_c('br'),_c('EmailAuthentication'),_c('br'),_c('br'),_c('br'),_c('GoogleAuthentication'),_c('br'),_c('br'),_c('br'),_c('TechnicalWorksModule')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }